import React from "react";
import { Typography, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "../myAccount/ChangePasswordView.styles";
import { Breadcrumbs } from "../../components/Breadcrumbs/Breadcrumbs";
import { CenteredContainer } from "../../components/CenteredContainer/CenteredContainer";

export interface IChangePasswordSuccessViewProps extends WithStyles<typeof styles> {}

export const ChangePasswordSuccessViewPure: React.FunctionComponent<IChangePasswordSuccessViewProps> = ({
    classes
}: IChangePasswordSuccessViewProps) => {
    return (
        <CenteredContainer>
            <Breadcrumbs
                items={[
                    { title: "My account", href: "/my-account" },
                    { title: "Change Password" }
                ]}
            />
            <div className={classes.header}>
                <Typography variant="h2">Change Password</Typography>
            </div>
            <Typography variant="h4">Your password has been changed.</Typography>
        </CenteredContainer>
    );
};

export const ChangePasswordSuccessView = withStyles(styles)(ChangePasswordSuccessViewPure);
